import { connect } from "react-redux"
import makeStyles from "@material-ui/core/styles/makeStyles"

import TableContainer from "@material-ui/core/TableContainer"

const useStyles = makeStyles(theme => ({
    root: {
        "& tbody .MuiTableRow-root:nth-of-type(odd)": {
            backgroundColor: theme.palette.grey[100]
        },
        "& tbody .MuiTableRow-root:hover": {
            backgroundColor: theme.palette.grey[200]
        }
    }
}))

const AdminTableContainer = props => {
    const { inputHeight, children } = props
    const classes = useStyles()

    return (
        <TableContainer
            className={classes.root}
            style={{ height: inputHeight }}
        >
            {children}
        </TableContainer>
    )
}

function mapStateToProps(state) {
    return {
        toolbarHeight: state.app.toolbarHeight,
        inputHeight: state.app.inputHeight
    }
}

export default connect(mapStateToProps)(AdminTableContainer)
